export default __webpack_public_path__ + "ac062d1b428513b9c13d11026d330e34.jpg";